import { Check } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
import { useActiveOrganization } from '@repo/api-client/react';
import { Button } from '@/components/ui/button';
import { Page } from '@/features/common/PageHeader';
import { displayWireMoney } from '@/features/money';

/**
 * Post-send celebration. Query params: client, amount (wire minor-units
 * string), invoiceId, currency (optional).
 */
export function InvoiceSentScreen() {
  const [params] = useSearchParams();
  const org = useActiveOrganization();
  const client = params.get('client') ?? 'your client';
  const amountMinor = params.get('amount') ?? '0';
  const currency = params.get('currency') ?? org?.currency ?? 'USD';
  const invoiceId = params.get('invoiceId');

  return (
    <Page>
      <div className="mx-auto flex max-w-lg flex-col items-center py-20 text-center">
        <div className="mb-7 flex size-20 items-center justify-center rounded-full bg-success/15">
          <Check className="size-10 text-success" strokeWidth={2.5} />
        </div>
        <h1 className="font-display text-3xl font-semibold tracking-tight text-foreground">
          Sent to {client}
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {displayWireMoney(amountMinor, currency)} · You&apos;ll be notified when paid
        </p>
        <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row">
          {invoiceId ? (
            <Button variant="outline" asChild className="flex-1">
              <Link to={`/invoices/${invoiceId}`}>Open invoice</Link>
            </Button>
          ) : (
            <Button variant="outline" asChild className="flex-1">
              <Link to="/invoices">All invoices</Link>
            </Button>
          )}
          <Button asChild className="flex-1">
            <Link to="/">Done</Link>
          </Button>
        </div>
      </div>
    </Page>
  );
}
